import Head from "next/head";

import type { JsonLdNode } from "@/lib/seo/schema";

const CONTEXT = "https://schema.org";

const JsonLd = ({ nodes }: { nodes: JsonLdNode[] }) => {
  if (!nodes.length) return null;

  const payload =
    nodes.length === 1
      ? { "@context": CONTEXT, ...nodes[0] }
      : { "@context": CONTEXT, "@graph": nodes };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(payload).replace(/</g, "\\u003c") }}
      />
    </Head>
  );
};

export default JsonLd;
